import initializeButtonGroups from '../utilities/initializeButtonGroups.js';

/**
 * 全ページの基底クラス
 */
export default class BasePage {
  #app;
  #container;

  constructor(app) {
    this.#app = app;
    this.#container = document.querySelector('[data-ref="diagnosisContent"]');
  }

  /**
   * サブクラスからアクセス可能なアプリインスタンス
   */
  get _app() {
    return this.#app;
  }

  /**
   * サブクラスからアクセス可能なコンテナ要素
   */
  get _container() {
    return this.#container;
  }

  /**
   * ページをレンダリング（サブクラスで実装必須）
   */
  render() {
    throw new Error('render() must be implemented by subclass');
  }

  /**
   * イベントをバインド（サブクラスでオプション実装）
   */
  bindEvents() {
    // オプショナル：サブクラスで実装
  }

  /**
   * バリデーション（サブクラスでオプション実装）
   */
  validate() {
    return true;
  }

  /**
   * ボタングループを初期化
   */
  _initializeButtonGroups() {
    initializeButtonGroups();
  }
}
